import clsx from 'clsx';
import type * as React from 'react';

export function HomeSection(props: {
    className?: string;
    children: React.ReactNode;
}): React.ReactElement {
    return (
        <section className={clsx('flex flex-col gap-4', props.className)}>{props.children}</section>
    );
}

export function HomeSectionHeading(props: { children: React.ReactNode }): React.ReactElement {
    return <h2 className="text-ui-heading-small">{props.children}</h2>;
}

export function HomeSectionBody(props: {
    className?: string;
    children: React.ReactNode;
}): React.ReactElement {
    return <div className={clsx('flex gap-6', props.className)}>{props.children}</div>;
}
